import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/translations';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
const Mission: React.FC = () => {
  const { language } = useLanguage();
  const t = translations[language];
  const [ref, isVisible] = useScrollAnimation(0.2);

  return (
    <section
      id="mission"
      className={`mission-section fade-in ${isVisible ? 'visible' : ''}`}
      ref={ref}
    >
      <div className="container">
        <h2 className="section-title">{t.mission.title}</h2>
        <div className="mission-content">
          <div className="mission-text">
            <p>{t.mission.description}</p>
            <p>{t.mission.intro}</p>
            <ul className="expertise-list">
              {t.mission.expertise.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
          <div className="mission-image">
            <img src="/images/mission.jpg" alt="Mission Sparkr" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mission;

